import { FC } from "react";
import RichTextEditor from "../libraryItem/course/RichTextEditor";
import TiptapEditorContextProvider from "../libraryItem/course/contexts/TiptapEditorContext";
import { cn } from "@src/lib/utils/cn";
import { CSSProperties } from "react";

type Props = {
  text: string;
  isSelected: boolean;
  maxWidth?: number;
  styleOverrides?: CSSProperties;
  className?: string;
};

const RichTextPreview: FC<Props> = ({
  text,
  isSelected,
  styleOverrides,
  className,
}) => {
  return (
    <TiptapEditorContextProvider>
      <RichTextEditor
        text={text}
        disabled={true}
        hasEditContentPermission={false}
        enableMentions
        className={cn(
          "m-0 truncate text-[14px] leading-[20px] tracking-[-0.006em] text-foreground",
          isSelected && "text-gray-11",
          className,
        )}
        styles={styleOverrides}
      />
    </TiptapEditorContextProvider>
  );
};

export default RichTextPreview;
